import { render } from "./HighlightResult.vue?vue&type=template&id=be144f7a&scoped=true"
import script from "./HighlightResult.vue?vue&type=script&lang=js"
export * from "./HighlightResult.vue?vue&type=script&lang=js"

import "./HighlightResult.vue?vue&type=style&index=0&id=be144f7a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be144f7a"]])

export default __exports__